import React from "react";
import { useState } from "react";

import imageOne from "../../../assets/lesson 6.1.png";
import imageTwo from "../../../assets/lesson 5.2.png";

function LessonSeven() {
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [q6, setQ6] = useState("");
  const [q7, setQ7] = useState("");
  const [q8, setQ8] = useState("");
  const [q9, setQ9] = useState("");
  const [q10, setQ10] = useState("");
  const [q11, setQ11] = useState("");
  const [q12, setQ12] = useState("");
  const [q13, setQ13] = useState("");
  const [q14, setQ14] = useState("");
  const [q15, setQ15] = useState("");
  const [q16, setQ16] = useState("");
  const [q17, setQ17] = useState("");
  const [q18, setQ18] = useState("");
  const [q19, setQ19] = useState("");
  const [q20, setQ20] = useState("");
  const [q21, setQ21] = useState("");
  const [q22, setQ22] = useState("");
  const [q23, setQ23] = useState("");
  const [q24, setQ24] = useState("");
  const [q25, setQ25] = useState("");
  const [q26, setQ26] = useState("");
  const [q27, setQ27] = useState("");
  const [q28, setQ28] = useState("");
  const [q29, setQ29] = useState("");
  const [q30, setQ30] = useState("");
  const [q31, setQ31] = useState("");
  const [q32, setQ32] = useState("");
  const [q33, setQ33] = useState("");
  const [q34, setQ34] = useState("");
  const [q35, setQ35] = useState("");
  const [q36, setQ36] = useState("");
  const [q37, setQ37] = useState("");
  const [q38, setQ38] = useState("");
  const [q39, setQ39] = useState("");
  const [q40, setQ40] = useState("");
  return (
    <>
      <div className="">
        <div className="task-one mb-3">
          <h4>
            <span>7.1</span> Write the negative.
          </h4>
          <p className="table row">
            <ol className="">
              <li>
                I play the piano very well.
                <input
                  className="border"
                  value="I don't play the piano very well."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                Anna plays the piano very well. Anna
                <input
                  className="border"
                  onChange={(e) => setQ1(e.target.value)}
                  style={{
                    background:
                      q1.trim() === "doesn't play the piano very well."
                        ? "#198754"
                        : "white",
                    color:
                      q1.trim() === "doesn't play the piano very well."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                They know my phone number. They
                <input
                  className="border"
                  onChange={(e) => setQ2(e.target.value)}
                  style={{
                    background:
                      q2.trim() === "don't know my phone number."
                        ? "#198754"
                        : "white",
                    color:
                      q2.trim() === "don't know my phone number."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                We work very hard.
                <input
                  className="border"
                  onChange={(e) => setQ3(e.target.value)}
                  style={{
                    background:
                      q3.trim() === "We don't work very hard."
                        ? "#198754"
                        : "white",
                    color:
                      q3.trim() === "We don't work very hard."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                He has a bath every day.
                <input
                  className="border"
                  onChange={(e) => setQ4(e.target.value)}
                  style={{
                    background:
                      q4.trim() === "he doesn't have a bath every day."
                        ? "#198754"
                        : "white",
                    color:
                      q4.trim() === "he doesn't have a bath every day."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                You do the same thing every day.
                <input
                  className="border"
                  onChange={(e) => setQ5(e.target.value)}
                  style={{
                    background:
                      q5.trim() === "You don't do the same thing every day."
                        ? "#198754"
                        : "white",
                    color:
                      q5.trim() === "You don't do the same thing every day."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-two mb-3">
          <h4>
            <span>7.2</span> Complete the sentences . All of them are negative.
            Use <strong>don't / doesn't</strong> + these verbs:
          </h4>
          <p className="table row">
            <ul className="border d-flex justify-content-evenly">
              <li>cost</li>
              <li>go</li>
              <li>know</li>
              <li className="strike">rain</li>
              <li>see</li>
              <li>use</li>
              <li>wear</li>
            </ul>
            {/* <img src={imageOne} /> */}
            <ol className="">
              <li>
                The weather here is usually nice. It
                <input
                  className="border"
                  value="doesn't rain"
                  disabled
                  onChange={(e) => setQ6(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                much.
              </li>
              <li>
                Paul has a car, but he
                <input
                  className="border"
                  onChange={(e) => setQ7(e.target.value)}
                  style={{
                    background:
                      q7.trim() === "doesn't use" ? "#198754" : "white",
                    color: q7.trim() === "doesn't use" ? "white" : "black",
                  }}
                />
                it very often.
              </li>
              <li>
                Paul and his friends like films, but they
                <input
                  className="border"
                  onChange={(e) => setQ8(e.target.value)}
                  style={{
                    background: q8.trim() === "don't go" ? "#198754" : "white",
                    color: q8.trim() === "don't go" ? "white" : "black",
                  }}
                />
                to the cinema very often.
              </li>
              <li>
                Amanda is married, but she
                <input
                  className="border"
                  onChange={(e) => setQ9(e.target.value)}
                  style={{
                    background:
                      q9.trim() === "doesn't wear" ? "#198754" : "white",
                    color: q9.trim() === "doesn't wear" ? "white" : "black",
                  }}
                />
                a ring.
              </li>
              <li>
                I
                <input
                  className="border"
                  onChange={(e) => setQ10(e.target.value)}
                  style={{
                    background:
                      q10.trim() === "don't know" ? "#198754" : "white",
                    color: q10.trim() === "don't know" ? "white" : "black",
                  }}
                />
                much about politics. I'm not interested in it.
              </li>
              <li>
                The Regent Hotel isn't expensive. It
                <input
                  className="border"
                  onChange={(e) => setQ11(e.target.value)}
                  style={{
                    background:
                      q11.trim() === "doesn't cost" ? "#198754" : "white",
                    color: q11.trim() === "doesn't cost" ? "white" : "black",
                  }}
                />
                much to stay there.
              </li>
              <li>
                Ed lives very near us, but we
                <input
                  className="border"
                  onChange={(e) => setQ12(e.target.value)}
                  style={{
                    background:
                      q12.trim() === "don't see" ? "#198754" : "white",
                    color: q12.trim() === "don't see" ? "white" : "black",
                  }}
                />
                him very often.
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-three mb-3 row ">
          <h4>
            <span>7.3</span> Put the verb into the correct form, positive or
            negative.
          </h4>
          <p className="table row">
            {/* <ul className="border d-flex justify-content-evenly">
              <li>boil</li>
              <li>close</li>
              <li>cost</li>
              <li>cost</li>
              <li>like</li>
              <li>like</li>
              <li>meet</li>
              <li>open</li>
              <li className="strike">speak</li>
              <li>teach</li>
              <li>wash</li>
            </ul> */}
            <ol>
              <li>
                Margaret
                <input
                  className="border"
                  value="speaks"
                  disabled
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                four langauges - English, French, German, and Spanish.{" "}
                <strong>(speak)</strong>
              </li>
              <li>
                I
                <input
                  className="border"
                  onChange={(e) => setQ13(e.target.value)}
                  style={{
                    background:
                      q13.trim() === "don't like" ? "#198754" : "white",
                    color: q13.trim() === "don't like" ? "white" : "black",
                  }}
                />
                my job. It's very boring. <strong>(like)</strong>
              </li>
              <li>
                'Where's Steve?' 'I'm sorry. I
                <input
                  className="border"
                  onChange={(e) => setQ14(e.target.value)}
                  style={{
                    background:
                      q14.trim() === "don't know" ? "#198754" : "white",
                    color: q14.trim() === "don't know" ? "white" : "black",
                  }}
                />
                .' <strong>(know)</strong>
              </li>
              <li>
                Sue is a very quiet person. She
                <input
                  className="border"
                  onChange={(e) => setQ15(e.target.value)}
                  style={{
                    background:
                      q15.trim() === "doesn't talk" ? "#198754" : "white",
                    color: q15.trim() === "doesn't talk" ? "white" : "black",
                  }}
                />
                very much. <strong>(talk)</strong>
              </li>
              <li>
                Andy
                <input
                  className="border"
                  onChange={(e) => setQ16(e.target.value)}
                  style={{
                    background: q16.trim() === "drinks" ? "#198754" : "white",
                    color: q16.trim() === "drinks" ? "white" : "black",
                  }}
                />
                a lot of tea. It's his favourite drink. <strong>(drink)</strong>
              </li>
              <li>
                It's not true! I
                <input
                  className="border"
                  onChange={(e) => setQ17(e.target.value)}
                  style={{
                    background:
                      q17.trim() === "don't believe" ? "#198754" : "white",
                    color: q17.trim() === "don't believe" ? "white" : "black",
                  }}
                />
                it. <strong>(believe)</strong>
              </li>
              <li>
                That's a very beautiful picture. I
                <input
                  className="border"
                  onChange={(e) => setQ18(e.target.value)}
                  style={{
                    background: q18.trim() === "like" ? "#198754" : "white",
                    color: q18.trim() === "like" ? "white" : "black",
                  }}
                />
                it very much. <strong>(like)</strong>
              </li>
              <li>
                Mark is a vegetarian. He
                <input
                  className="border"
                  onChange={(e) => setQ19(e.target.value)}
                  style={{
                    background:
                      q19.trim() === "doesn't eat" ? "#198754" : "white",
                    color: q19.trim() === "doesn't eat" ? "white" : "black",
                  }}
                />
                meat. <strong>(eat)</strong>
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-four mb-3">
          <h4>
            <span>7.4</span> Write about yourself. Use:
            <span>
              <strong> I never </strong> or <strong> I often </strong>
              <strong> I don't... very often </strong>
            </span>
          </h4>
          <p className="table row">
            <ol className="">
              <li>
                (watch TV)
                <input
                  className="border"
                  value="I don't watch TV very often."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
                or
                <input
                  className="border"
                  value="I never watch TV."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
                or
                <input
                  className="border"
                  value="I often watch TV."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                (go to the theatre) I
                <input
                  className="border"
                  onChange={(e) => setQ23(e.target.value)}
                  style={{
                    background: q23.trim() !== "" ? "#198754" : "white",
                    color: q23.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (ride a bike)
                <input
                  className="border"
                  onChange={(e) => setQ24(e.target.value)}
                  style={{
                    background: q24.trim() !== "" ? "#198754" : "white",
                    color: q24.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (eat in restaurants)
                <input
                  className="border"
                  onChange={(e) => setQ25(e.target.value)}
                  style={{
                    background: q25.trim() !== "" ? "#198754" : "white",
                    color: q25.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (tavel by train)
                <input
                  className="border"
                  onChange={(e) => setQ26(e.target.value)}
                  style={{
                    background: q26.trim() !== "" ? "#198754" : "white",
                    color: q26.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        {/* <hr /> */}

        {/* <div className="task-four mb-3">
          <h4>
            <span>5.4</span> Write sentences about yourself. Use
            <span>
              <strong> always / never / often / usually / sometimes. </strong>
            </span>
          </h4>
          <p className="table row">
            <ol className="border">
              <li>
                (watch TV in the evening)
                <input
                  className="border"
                  value="I usually watch TV in the evening."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                (read in bed) I
                <input
                  className="border"
                  onChange={(e) => setQ31(e.target.value)}
                  style={{
                    background: q31.trim() !== "" ? "#198754" : "white",
                    color: q31.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (get up before 7 o'clock)
                <input
                  className="border"
                  onChange={(e) => setQ32(e.target.value)}
                  style={{
                    background: q32.trim() !== "" ? "#198754" : "white",
                    color: q32.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (go to work/school by bus)
                <input
                  className="border"
                  onChange={(e) => setQ33(e.target.value)}
                  style={{
                    background: q33.trim() !== "" ? "#198754" : "white",
                    color: q33.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (drink coffee in the morning)
                <input
                  className="border"
                  onChange={(e) => setQ34(e.target.value)}
                  style={{
                    background: q34.trim() !== "" ? "#198754" : "white",
                    color: q34.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div> */}
      </div>
    </>
  );
}

export default LessonSeven;
